import EachQuestion from "../general/EachQuestion";
import * as theme from "../theme";

const LocationGroupOpenedQuestions = ({
  questionsOrder,
  formid,
  groupid,
  locationid,
  isLastGroup,
  isBuilding,
  buildingIndex,
}) => {
  return (
    <div
      style={{
        minHeight: theme.SCALES.openedQuestionMinHeight,
        display: "flex",
        flexDirection: "column",
        paddingTop: theme.SCALES.paddingTopInEachQuestionList,
        paddingBottom: theme.SCALES.paddingTopInEachQuestionList,
        paddingLeft: theme.SCALES.openedQuestionsLeftPadding,
        paddingRight: theme.SCALES.openedQuestionsRightPadding,
        backgroundColor: theme.COLORS.help_tip,
        borderBottomRightRadius: isLastGroup
          ? theme.SCALES.groupTabBorderRadius
          : 0,
        borderBottomLeftRadius: isLastGroup
          ? theme.SCALES.groupTabBorderRadius
          : 0,
      }}
    >
      {questionsOrder.map((questionid) => (
        <EachQuestion
          key={`${formid}_${groupid}_${questionid}_node`}
          formid={formid}
          locationid={locationid}
          questionid={questionid}
          isBuilding={isBuilding}
          buildingIndex={buildingIndex}
          groupid={groupid}
        ></EachQuestion>
      ))}
    </div>
  );
};

export default LocationGroupOpenedQuestions;
